const getters = {

    scroll: (state) => state.scroll
}

export default getters
